import React from 'react';
import { apiRequest } from '@repo/utils/helpers/api';
import { getStoredOauthParams, OauthLogin, OauthParams } from '../OauthLogin';

export default function OauthCallback({ integration }: { integration: 'chatgpt' | 'notion' }) {
  const getOauthParams = (searchParams: URLSearchParams): OauthParams => {
    let code = searchParams.get('code');
    let state = searchParams.get('state');

    if (!code) {
      const storedParams = getStoredOauthParams();

      if (!storedParams) {
        return undefined;
      }

      code = storedParams.code;
      state = storedParams.state;
    }

    if (code) {
      return { code, state };
    }

    return undefined;
  };

  const postOauthParams = async (oauthParams: OauthParams) =>
    apiRequest<any>(
      'POST',
      `/integrations/external/${integration}/callback/`,
      {
        code: oauthParams.code,
        state: oauthParams.state,
        redirect_uri: `${window.location.protocol}//${location.host}${location.pathname}`,
      },
      {
        apiVersion: 'v2',
        noTimeZone: true,
      },
    );

  return (
    <OauthLogin
      getOauthParams={getOauthParams}
      postOauthParams={postOauthParams}
      integration={integration}
    />
  );
}
